import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

/**
 * Road distances from the employee's home address to each worksite.
 *
 * Proxied rather than called directly: Google's Distance Matrix endpoint sends
 * no Access-Control-Allow-Origin header, so the browser cannot reach it the way
 * it reaches Geocoding.
 */
export const postReportDistanceMatrix = async (origin, destinations) => {
  const apiPath = 'report/distance-matrix';

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: { origin, destinations },
    isLocalApiRequest: false,
  });

  const response = await axios(signedRequest);

  return response.data.distances;
};
